import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { spacing, breakpoints } from '@naf/theme';
import { nafColor } from '@nafcore/theme';

export const CompetitionWrapper = styled.div`
  p {
    margin: 0 !important;
  }
`;

export const EndDateText = styled.div`
  margin-top: ${spacing.space12};
`;

export const SubmitButtonWrapper = styled.div`
  margin-top: ${spacing.space16};
  width: 100%;

  button {
    width: 100%;

    @media (min-width: ${breakpoints.m}) {
      width: fit-content;
      min-width: 127px;
    }
  }
`;

export const TermsContainer = styled.div<{ $style?: 'spruce' | 'white' }>`
  display: flex;
  flex-direction: column;
  margin-top: ${spacing.space12};
`;

export const SpruceCheckboxWrapper = styled.div<{ $isSpruceMode: boolean }>`
  ${({ $isSpruceMode }) =>
    $isSpruceMode &&
    css`
      p {
        color: ${nafColor.signature.white};
      }
    `}
`;
